import React from "react";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from "../../context/AuthContext";

export default function SessionAlerts() {
  const { sessionToast, setSessionToast } = useAuth();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSessionToast((prev) => ({ ...prev, open: false }));
  };

  return (
    <Snackbar
      open={sessionToast.open}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity={sessionToast.severity} variant="filled" onClose={handleClose} sx={{ width: "100%" }}>
        {sessionToast.message}
      </Alert>
    </Snackbar>
  );
}
